<template>
  <div class="mydialog">
    <div class="mycontent">
      <div class="myheader">
        <h4>必孚集市板块目前针对APP开放</h4>
        <h5>请扫描下方二维码下载体验</h5>
        <hr>
      </div>
      <div class="mybody">
        <img src="@/assets/image/newappqrcode.png" width="200px; height: 200px;" alt="必孚APP下载">
      </div>
      <div class="myfooter">
        <span>适用于Android及iOS系统</span>
      </div>
      <button id="close" class="close" @click="closeDialog">&times;</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.mydialog {
    width: 360px;
    height: 397px;
    box-shadow: 0 2px 3px #999;
    /* background-color: tomato; */
    background: #ffffff;
}
.mycontent {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
.myheader {
    text-align: center;
    margin-top: 20px;
}
.myfooter {
    margin-top: 20px;
}
.close {
  position: absolute;
  top: 10px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoMarket/index.vue